import React, { useState } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Alert,
    CircularProgress
} from '@mui/material';
import authService from '../../services/authService';

const ChangePasswordDialog = ({ open, onClose }) => {
    const [formData, setFormData] = useState({
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
    });
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState({ type: '', text: '' });

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
        // Limpiar errores al escribir
        if (message.type === 'error') setMessage({ type: '', text: '' });
    };

    const handleClose = () => {
        setFormData({
            currentPassword: '',
            newPassword: '',
            confirmPassword: ''
        });
        setMessage({ type: '', text: '' });
        onClose();
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage({ type: '', text: '' });

        if (formData.newPassword !== formData.confirmPassword) {
            setMessage({ type: 'error', text: 'Las contraseñas nuevas no coinciden' });
            return;
        }

        if (formData.newPassword.length < 6) {
            setMessage({ type: 'error', text: 'La contraseña debe tener al menos 6 caracteres' });
            return;
        }

        setLoading(true);

        try {
            const response = await authService.changePassword(
                formData.currentPassword,
                formData.newPassword
            );

            setMessage({ type: 'success', text: response.message || 'Contraseña actualizada correctamente' });

            // Cerrar después de 2 segundos si todo salió bien
            setTimeout(() => {
                handleClose();
            }, 2000);

        } catch (error) {
            console.error('Error changing password:', error);
            setMessage({
                type: 'error',
                text: error.response?.data?.message || 'Error al actualizar la contraseña'
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <Dialog open={open} onClose={!loading ? handleClose : undefined} maxWidth="sm" fullWidth>
            <DialogTitle>Cambiar Contraseña</DialogTitle>
            <form onSubmit={handleSubmit}>
                <DialogContent>
                    {message.text && (
                        <Alert severity={message.type} sx={{ mb: 2 }}>
                            {message.text}
                        </Alert>
                    )}

                    <TextField
                        margin="dense"
                        label="Contraseña Actual"
                        type="password"
                        fullWidth
                        name="currentPassword"
                        value={formData.currentPassword}
                        onChange={handleChange}
                        required
                        disabled={loading}
                    />
                    <TextField
                        margin="dense"
                        label="Nueva Contraseña"
                        type="password"
                        fullWidth
                        name="newPassword"
                        value={formData.newPassword}
                        onChange={handleChange}
                        required
                        disabled={loading}
                        helperText="Mínimo 6 caracteres"
                    />
                    <TextField
                        margin="dense"
                        label="Confirmar Nueva Contraseña"
                        type="password"
                        fullWidth
                        name="confirmPassword"
                        value={formData.confirmPassword}
                        onChange={handleChange}
                        required
                        disabled={loading}
                    />
                </DialogContent>
                <DialogActions sx={{ px: 3, pb: 2 }}>
                    <Button onClick={handleClose} disabled={loading}>
                        Cancelar
                    </Button>
                    <Button
                        type="submit"
                        variant="contained"
                        disabled={loading}
                    >
                        {loading ? <CircularProgress size={24} /> : 'Actualizar'}
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};

export default ChangePasswordDialog;
